<template>
  <div class="dayplanner-suggestions p-2">
    <template v-if="selection !== null">
      <el-button @click="selection = null">&larr; Go back</el-button>
    </template>
    <template v-if="selection === null">
      <div class="p-4">
        <el-button class="btn-block ml-0" @click="selection = 'daily-routine-objects-actions'">Daily Routine Pack</el-button>
        <el-button class="btn-block ml-0" @click="selection = 'design-thinking'">Design Thinking Pack</el-button>
        <el-button class="btn-block ml-0" @click="selection = 'startups'">Startup Pack</el-button>
        <el-button class="btn-block ml-0" @click="selection = 'motivation'">Motivation Toolbox</el-button>
      </div>
    </template>

    <template v-if="selection === 'design-thinking'">
      <h3 class="text-center">Design Thinking</h3>
      <DesignThinkingPackage />
    </template>
    <template v-if="selection === 'daily-routine-objects-actions'">
      <h3 class="text-center">Daily Routine</h3>
      <EveryDayPackage />
    </template>
    <template v-if="selection === 'startups'">
      <h3 class="text-center">Startups</h3>
      <StartUpPackage />
    </template>
    <template v-if="selection === 'motivation'">
      <h3 class="text-center">Motivation</h3>
      <MotivationToolbox />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DesignThinkingPackage from './SuggestionPacks/DesignThinkingPackage';
import EveryDayPackage from './SuggestionPacks/EveryDayPackage';
import StartUpPackage from './SuggestionPacks/StartUpPackage';
import MotivationToolbox from './SuggestionPacks/MotivationToolbox';

export default {
  data: () => ({
    selection: null
  }),
  mounted() {
  },
  computed: {
    ...mapGetters("dayplanner", [
      "dayplan_remaining_timeslots",
      "dayplan_from_db_at_selected_day",
      "view_selected_date",
      "view_selected_date_as_timestamp",
      "view_selected_date_as_yymmdd",
    ]),
  },
  methods: {
  },
  components: {
    DesignThinkingPackage,
    EveryDayPackage,
    StartUpPackage,
    MotivationToolbox,
  }
}
</script>
